import { useEffect, useRef } from "react";

export const useEffectOnce = ({
  effect,
  onError,
}: {
  effect: () => void;
  onError?: () => void;
}) => {
  const ran = useRef(false);
  const effectRef = useRef(effect);
  const onErrorRef = useRef(onError);
  effectRef.current = effect;
  onErrorRef.current = onError;

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    try {
      effectRef.current();
    } catch {
      onErrorRef.current?.();
    }
  }, []);
};
